export const changeValueOfDay = (
  id,
  setSelectedDayOfWeek,
  newArrOfSelectedDays,
) => {
  setSelectedDayOfWeek((prev) => {
    const newState = [...prev];
    newState[id] = newArrOfSelectedDays;
    return newState;
  });
};
